import Interfaces from "pages/data/interfaces"
import Benchmarks from "pages/master/Benchmarks"
import Inwards from "pages/master/Inwards"
import React from "react"
import { VesaRouteType } from "routes"

const dataRoutes: VesaRouteType[] = [
  {
    icon: "box",
    title: "Data View",
    path: "inwards",
    element: <Inwards />,
  },
  {
    icon: "comparison",
    path: "benchmarks",
    element: <Benchmarks />,
    title: "Benchmarks",
  },
  {
    icon: "third-party",
    path: "interfaces",
    permission: ["ds_view_interface"],
    element: <Interfaces />,
    title: "Interfaces",
  },
]

export default dataRoutes
